// extracted by mini-css-extract-plugin
export default {"description":"style_description__Cosim","fade-in":"style_fade-in__-H94D","top":"style_top__r3KfD","image":"style_image__FK0L5"};